import { FullScreenLoading } from '~/components/common';
import { useBlockAndReport, useModal } from '~/hooks';
import { ModalParams } from '~/types';
import BottomSheetContainer from '../BottomSheet';
import Inner from './BottomSheetInner';

interface BlockModalProps {
  character_id: string;
  showBlockCharacter: boolean;
  setShowBlockCharacter: (state: boolean) => void;
}

export default function BlockModal({
  character_id,
  showBlockCharacter,
  setShowBlockCharacter,
}: BlockModalProps) {
  const { openModal } = useModal();

  const {
    blockCharacter,
    setBlockCharacter,
    handleSendBlockAndReport,
    isReportPending,
  } = useBlockAndReport();

  const characterModalParams: ModalParams = {
    title: 'Block / Report',
    content: 'The blocked character cannot be viewed.',
    type: 'double_red',
    buttonName: 'Block',
    click: () =>
      handleSendBlockAndReport(character_id, () =>
        setShowBlockCharacter(false),
      ),
  };

  return (
    <>
      {isReportPending && <FullScreenLoading />}

      <BottomSheetContainer
        isOpen={showBlockCharacter}
        onClose={() => {
          setShowBlockCharacter(false);
          setBlockCharacter('');
        }}
      >
        <Inner
          id='CharacterBlockAndReport'
          title={'Block / Report character'}
          desc={'What is the reason you wish to block/report this character?'}
          placeholder={''}
          text={blockCharacter}
          setText={setBlockCharacter}
          onClick={() => openModal(characterModalParams)}
          maxText={200}
        />
      </BottomSheetContainer>
    </>
  );
}
